(function () {
  'use strict';

  var refreshTimer;
  var settleTimer;
  var checkingGift = false;

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    window.clearTimeout(settleTimer);
    refreshTimer = window.setTimeout(refreshCart, 250);
    /* Gift apps update after Shopify confirms the paid line. Reconcile once
       more after that independent request settles. */
    settleTimer = window.setTimeout(function () {
      removeOrphanedGift().then(refreshCart);
    }, 1800);
  }

  function isPromotionalGift(item) {
    var discountedToFree = item.final_line_price === 0 && item.original_line_price > 0;
    var giftDiscount = (item.discounts || []).some(function (discount) {
      return /gift|wine knife/i.test(discount.title || '');
    });
    return discountedToFree && giftDiscount;
  }

  function removeOrphanedGift() {
    if (checkingGift) return Promise.resolve(false);
    checkingGift = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var gifts = cart.items.filter(isPromotionalGift);
        var paidItems = cart.items.filter(function (item) { return !isPromotionalGift(item); });
        if (!gifts.length || paidItems.length) return false;

        var updates = {};
        gifts.forEach(function (gift) { updates[gift.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not remove an orphaned promotional gift.');
          return true;
        });
      })
      .catch(function (error) {
        console.error('[NON] Promotional gift reconciliation failed.', error);
        return false;
      })
      .finally(function () { checkingGift = false; });
  }

  window.addEventListener('baseline:cart:afteradditem', scheduleRefresh);
  window.addEventListener('baseline:cart:cartqtychange', scheduleRefresh);
  document.addEventListener('non:cart:added', scheduleRefresh);
  window.addEventListener('pageshow', function () {
    removeOrphanedGift().then(function (changed) { if (changed) refreshCart(); });
  });
})();
